import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'

import './info-inline.pcss'

const InfoInline = ({ text, hideIcon = false }) => {
    return (
        <div className="info-inline">
            {!hideIcon && <Icon name="icon_info_circle" size="m" />}
            <span>{text}</span>
        </div>
    )
}

InfoInline.propTypes = {
    text: PropTypes.string.isRequired,
    hideIcon: PropTypes.bool,
}

export default InfoInline
